import { useLingui } from '@lingui/react/macro'
import { captureException } from '@sentry/core'
import { ErrorComponentProps, SearchParamError } from '@tanstack/react-router'
import { ErrorScreen } from 'components/ErrorScreen'
import React, { useEffect } from 'react'
import { styled } from 'styled-components'

const StyledErrorPageLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.forecast.background3};
`

const StyledGoBackButton = styled.button`
  color: ${({ theme }) => theme.forecast.activeText};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  background-color: ${({ theme }) => theme.forecast.background4};
  padding: 4px 8px;
`

export function ErrorFallback({ error }: ErrorComponentProps) {
  const { t } = useLingui()
  const isSearchParamError = error instanceof SearchParamError

  useEffect(() => {
    if (!isSearchParamError) {
      captureException(error)
    }
  }, [error, isSearchParamError])

  const title = isSearchParamError
    ? t`This page link is incomplete`
    : t`Something went wrong`

  let message: string
  if (isSearchParamError) {
    message = t`The link you followed is missing required information. Try going back, or open the page from the menu.`
  } else if (error instanceof Error) {
    message = error.message
  } else if (typeof error === 'string') {
    message = error
  } else {
    message = t`Unknown error`
  }

  return (
    <StyledErrorPageLayout>
      <ErrorScreen title={title} message={message}>
        <StyledGoBackButton onClick={() => window.history.back()}>
          {t`Go back`}
        </StyledGoBackButton>
      </ErrorScreen>
    </StyledErrorPageLayout>
  )
}
